// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"992":"0ffeb9cd","2340":"0ffeb9cd","2960":"05f02e9f","4472":"ff6c189a","6024":"d169caca","6456":"9413be07","8204":"9413be07","9032":"f38e91c0"}[chunkId] + ".chunk.css";
};